<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <fieldset formGroupName="generalSettings">
          <legend>
            {{ pageVocabs + "legends.generalSettings" | translate }}
          </legend>

          <div class="row">
            <!-- parentId -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <zones-select-search
                *ngIf="model.type !== ZoneType.Country"
                class="tw-w-full"
                [label]="
                  (zoneTypeForSelectSearch > 0
                    ? ZoneTypeDisplay[zoneTypeForSelectSearch]
                    : 'common.parent'
                  ) | translate
                "
                type="byZoneType"
                [zoneType]="zoneTypeForSelectSearch"
                [control]="form?.get('parentId')"
                [id]="'null'"
                [removable]="formPageConfig.isEditMode ? false : true"
                [(value)]="model.parentId"
                (onError)="onClose()"
              >
              </zones-select-search>
            </div>

            <!-- type -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <enum-select-search
                enumName="ZoneType"
                label="common.type"
                [control]="form?.get('type')"
                [(value)]="model.type"
                (valueChange)="changeZoneType($event)"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- name -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.name"
                [control]="form?.get('name')"
                label="common.name"
                [maxLength]="64"
              >
              </form-field>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- generalSettings -->
      <section>
        <fieldset formGroupName="mapSetting">
          <legend>
            {{ pageVocabs + "legends.mapSetting" | translate }}
          </legend>

          <div class="row">
            <div class="tw-w-full">
              <smart-send-map-control
                #Map
                [isShowPolygonOptions]="false"
                [ShowSaveButton]="false"
                (OnLoad)="onMapReady()"
                (OnHelp)="showMapHelp($event)"
                (OnSave)="onMapSaveButtonClicked($event)"
                [Theme]="appStateService.currentThemeMode()"
              ></smart-send-map-control>
            </div>
          </div>
        </fieldset>
      </section>
      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
